module.exports = __webpack_public_path__ + "static/OR0-2115746ec5653cd88cd8d658b82c3163.jpg";